import ProductService from '@/api/ProductService'
import CategoryService from '@/api/CategoryService'
import ModifierService from '@/api/ModifierService'
import DiscountService from '@/api/DiscountService'
import TaxService from '@/api/TaxService'
import RecipeService from '@/api/RecipeService'

// initial state
const state = {
  products: [],
  product: null,
  tableopts: {},
  categories: [],
  category: null,
  modifiers: [],
  modifier: null,
  discounts: [],
  discount: null,
  taxes: [],
  taxesGroupNames: [],
  tax: null,
  units: [],
  names: [],
  barcodes: [],
  allSkuCode: [],
  nextSkuCode: [],
  allSkuAttributes: [],
  recipes: [],
  recipe: null,
}

// getters
const getters = {
  getProducts: state => state.products,
  getProduct: state => state.product,
  getTableopts: state => state.tableopts,
  getCategories: state => state.categories,
  getCategory: state => state.category,
  getModifiers: state => state.modifiers,
  getModifier: state => state.modifier,
  getDiscounts: state => state.discounts,
  getDiscount: state => state.discount,
  getTaxes: state => state.taxes,
  getTaxesGroupNames: state => state.taxesGroupNames,
  getTax: state => state.tax,
  getRecipes: state => state.recipes,
  getRecipe: state => state.recipe,
  getUnits: state => state.units,
  getNames: state => state.names,
  getBarcodes: state => state.barcodes,
  getProductInfoBySkuId: (state) => (sku_id) => {
    return state.products.find(p => {
      return p.prices.find(sku => sku.sku_id == sku_id)
    })
  },
  getProductFullNameBySkuId: (state) => (sku_id) => {
    let productInfo = state.products.find(p => { return p.prices.find(sku => sku.sku_id == sku_id) })

    // end this line
    if (!productInfo) return undefined

    let sku = productInfo.prices.find(sku => sku.sku_id == sku_id)
    let product_name = productInfo.product_name
    let attributes = sku.attributes
    var fullname = ''
    var option = ''
    for (let i in attributes) {
      if (i == 0) {
        option += '('
      }
      // option +=  attributes[i].name + ' '
      option += attributes[i].option
      if (i < attributes.length - 1) {
        option += ', '
      } else {
        option += ')'
      }
    }
    if (attributes.length > 0) {
      fullname = product_name + ' ' + option
    } else {
      fullname = product_name
    }
    return fullname
  },
  getCategoryNameById: (state) => (catId) => {
    const category = state.categories.find((cat) => cat.category_id === catId)
    return category ? category.category_name : null
  },
  getSkuInfoBySkuId: (state) => (sku_id, _products) => {
    const products = _products || state.products
    let productInfo = products.find(p => { return p.prices.find(sku => sku.sku_id == sku_id) })
    if (!productInfo) {
      return undefined
    }
    return productInfo.prices.find(sku => sku.sku_id == sku_id)
  },
  getNextSkuCode: (state) => state.nextSkuCode,
  getAllSkuCode: (state) => state.allSkuCode,
  getAllSkuAttributes: (state) => state.allSkuAttributes,
  isUseLot: (state) => (skuId) => {
    return state.products.some((product) => {
      return product.prices.some((price) => {
        return price.sku_id === skuId && (price.config && price.config.inventory.use_lot)
      })
    })
  },
  isUseSerial: (state) => (skuId) => {
    return state.products.some((product) => {
      return product.prices.some((price) => {
        return price.sku_id === skuId && (price.config && price.config.inventory.use_serial)
      })
    })
  },
  getSkuIdByProductName: (state) => (pName) => {
    const product = state.products.find((item) => item.product_name === pName)
    return product ? product.prices[0].sku_id : null
  },
  getSkuIdBySkuCode: (state) => (skuCode) => {
    for (const product of state.products) {
      for (const price of product.prices) {
        if (price.sku_code === skuCode) {
          return price.sku_id
        }
      }
    }
    return null
  },
  getStockIdBy: (state) => (skuId, whId) => {
    for (const product of state.products) {
      for (const price of product.prices) {
        if (price.sku_id === skuId) {
          for (const stock of price.stocks) {
            if (stock.warehouse_id === whId) {
              return stock.stock_id
            }
          }
        }
      }
    }
    return null
  },
  getProductIdBySkuId: (state) => (skuId) => {
    for (const product of state.products) {
      for (const price of product.prices) {
        if (price.sku_id === skuId) {
          return product.product_id
        }
      }
    }
    return null
  },
}

// mutations
const mutations = {
  setProduct (state, product) {
    state.product = product
  },
  clearProduct (state) {
    state.product = null
  },
  setProducts (state, products) {
    state.products = products
  },
  mergeProducts (state, products) {
    const productIds = state.products.map((productItem) => productItem.product_id)
    state.products = [
      ...state.products,
      ...products.filter((productItem) => !productIds.includes(productItem.product_id)),
    ]
  },
  clearProducts (state) {
    state.products = []
  },
  setTableopts (state, data) {
    state.tableopts = data
  },
  setCategories (state, data) {
    state.categories = data
  },
  setCategory (state, data) {
    state.category = data
  },
  setModifiers (state, data) {
    state.modifiers = data
  },
  setModifier (state, data) {
    state.modifier = data
  },
  setDiscounts (state, data) {
    state.discounts = data
  },
  setDiscount (state, data) {
    state.discount = data
  },
  setTaxes (state, data) {
    state.taxes = data
  },
  setTax (state, data) {
    state.tax = data
  },
  setTaxesGroupNames (state, data) {
    state.taxesGroupNames = data
  },
  setUnits (state, data) {
    state.units = data
  },
  setNames (state, data) {
    state.names = data
  },
  setBarcodes (state, data) {
    state.barcodes = data
  },
  setNextSkuCode (state, data) {
    state.nextSkuCode = data
  },
  setAllSkuCode (state, data) {
    state.allSkuCode = data
  },
  setAllSkuAttributes (state, data) {
    state.allSkuAttributes = data
  },
  setRecipes(state, data) {
    state.recipes = data
  },
  setRecipe(state, data) {
    state.recipe = data
  },
}

// actions
const actions = {
  async insertProduct ({ commit }, product) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await ProductService.insert(product)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getProduct ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getProduct') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getProduct')

      let response = await ProductService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getProduct')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setProduct', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearProduct ({ commit }) {
    commit('clearProduct')
  },
  async getProducts ({ commit }, _params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getProducts') >= 0) return

    try {
      const params = _params === undefined
        ? null
        : {
          ..._params,
          page: _params.page || 1,
          limit: _params.limit || 10,
          q: _params.q,
        }

      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getProducts')

      let response = await ProductService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getProducts')

      result = response.data

      if (result.success) {
        commit('setProducts', result.data)
        this.dispatch('setTableopts', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getProductWithMerge ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getProductWithMerge') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getProductWithMerge')

      let response = await ProductService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getProductWithMerge')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('mergeProducts', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getProductsWithMerge ({ commit }, _params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getProductsWithMerge') >= 0) return

    try {
      const params = _params === undefined
        ? null
        : {
          page: _params.page || 1,
          limit: _params.limit || 10,
          q: _params.q,
        }

      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getProductsWithMerge')

      let response = await ProductService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getProductsWithMerge')

      result = response.data

      if (result.success) {
        commit('mergeProducts', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async mergeProducts ({ commit }, products) {
    commit('mergeProducts', products)
  },
  clearProducts ({ commit }) {
    commit('clearProducts')
  },
  setTableopts ({ commit }, products) {
    var _tableopts = {
      image: false,
      pcode: false,
      barcode: false,
      sku: false,
      brand: false,
      category: false,
      modifier: false,
      discount: false,
      cost: false,
      stock: false,
      tax: false,
    }
    let foundImage,
      foundPcode,
      foundBarcode,
      foundSku,
      foundBrand,
      foundCategory,
      foundModifier,
      foundDiscount,
      foundCost,
      foundStock,
      foundTax

    for (let i in products) {
      let p = products[i]
      let prices = p.prices
      if (p.images.original && !foundImage) {
        _tableopts['image'] = true
        foundImage = true
      }
      if (p.brand_name && !foundBrand) {
        _tableopts['brand'] = true
        foundBrand = true
      }
      if (p.modifiers.length > 0 && !foundModifier) {
        _tableopts['modifier'] = true
        foundModifier = true
      }
      if (p.discounts.length > 0 && !foundDiscount) {
        _tableopts['discount'] = true
        foundDiscount = true
      }
      if (p.taxes.length > 0 && !foundTax) {
        _tableopts['tax'] = true
        foundTax = true
      }
      if (p.category_name && !foundCategory) {
        _tableopts['category'] = true
        foundCategory = true
      }
      for (let j in prices) {
        let price = prices[j]
        if (price.pcode && !foundPcode) {
          _tableopts['pcode'] = true
          foundPcode = true
        }
        if (price.barcode && !foundBarcode) {
          _tableopts['barcode'] = true
          foundBarcode = true
        }
        if (price.sku_code && !foundSku) {
          _tableopts['sku'] = true
          foundSku = true
        }
        if (price.cost != null && !foundCost) {
          _tableopts['cost'] = true
          foundCost = true
        }
        if (price.stocks.length > 0 && !foundStock) {
          _tableopts['stock'] = true
          foundStock = true
        }
      }
    }
    commit('setTableopts', _tableopts)
  },
  async getCategories ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getCategories') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getCategories')

      let response = await CategoryService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getCategories')

      result = response.data

      if (result.success) {
        commit('setCategories', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearCategories ({ commit }, data) {
    commit('setCategories', [])
  },
  async getCategory ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getCategory') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getCategory')

      let response = await CategoryService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getCategory')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setCategory', result.data[0])
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearCategory ({ commit }, data) {
    commit('setCategory', null)
  },
  async insertCategory ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await CategoryService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateCategory ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await CategoryService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteCategory ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await CategoryService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getModifiers ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getModifiers') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getModifiers')

      let response = await ModifierService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getModifiers')

      result = response.data

      if (result.success) {
        commit('setModifiers', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearModifiers ({ commit }, data) {
    commit('setModifiers', [])
  },
  async getModifier ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getModifier') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getModifier')

      let response = await ModifierService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getModifier')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setModifier', result.data[0])
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearModifier ({ commit }, data) {
    commit('setModifier', null)
  },
  async insertModifier ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ModifierService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateModifier ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ModifierService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteModifier ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ModifierService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getUnits ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getUnits') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getUnits')

      let response = await ProductService.getUnits()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getUnits')

      result = response.data

      if (result.success) {
        commit('setUnits', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getNames ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNames') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNames')

      let response = await ProductService.getNames()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNames')

      result = response.data

      if (result.success) {
        commit('setNames', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  async getBarcodes ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getBarcodes') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getBarcodes')

      let response = await ProductService.getBarcodes()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getBarcodes')

      result = response.data

      if (result.success) {
        commit('setBarcodes', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearUnits ({ commit }) {
    commit('setUnits', [])
  },
  async getDiscounts ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getDiscounts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getDiscounts')

      let response = await DiscountService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getDiscounts')

      result = response.data

      if (result.success) {
        commit('setDiscounts', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearDiscounts ({ commit }, data) {
    commit('setDiscounts', [])
  },
  async getDiscount ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getDiscount') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getDiscount')

      let response = await DiscountService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getDiscount')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setDiscount', result.data[0])
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearDiscount ({ commit }, data) {
    commit('setDiscount', null)
  },
  async insertDiscount ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await DiscountService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateDiscount ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await DiscountService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteDiscount ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await DiscountService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getTaxes ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getTaxes') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getTaxes')

      let response = await TaxService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getTaxes')

      result = response.data

      if (result.success) {
        commit('setTaxes', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearTaxes ({ commit }, data) {
    commit('setTaxes', [])
  },
  async getTax ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getTax') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getTax')

      let response = await TaxService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getTax')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setTax', result.data[0])
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearTax ({ commit }, data) {
    commit('setTax', null)
  },
  async getTaxesGroupNames ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getTaxesGroupNames') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getTaxesGroupNames')

      let response = await TaxService.getGroupNames()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getTaxesGroupNames')

      result = response.data

      if (result.success) {
        commit('setTaxesGroupNames', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async insertTax ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await TaxService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateTax ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await TaxService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteTax ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await TaxService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextSkuCode ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextSkuCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextSkuCode')

      let response = await ProductService.getSkuLatestCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextSkuCode')

      result = response.data

      if (result.success) {
        commit('setNextSkuCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getAllSkuCode ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getAllSkuCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getAllSkuCode')

      let response = await ProductService.getSkuAllCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getAllSkuCode')

      result = response.data

      if (result.success) {
        commit('setAllSkuCode', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getAllSkuAttributes ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getAllSkuAttributes') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getAllSkuAttributes')

      let response = await ProductService.getSkuAllAttributes()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getAllSkuAttributes')

      result = response.data

      if (result.success) {
        commit('setAllSkuAttributes', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateProduct ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ProductService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateProductByImport ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ProductService.updateByImport(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteProduct ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ProductService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async assignLotSerial ({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ProductService.assignLotSerial(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getRecipes ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getRecipes') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getRecipes')

      let response = await RecipeService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getRecipes')

      result = response.data

      if (result.success) {
        commit('setRecipes', result.data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getRecipe ({ commit }, { id }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getRecipe') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getRecipe')

      let response = await RecipeService.getSingle(id)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getRecipe')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setRecipe', result.data[0])
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async insertRecipe ({ commit }, { data }) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await RecipeService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateRecipe ({ commit }, { id, data }) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await RecipeService.update(id, data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteRecipe ({ commit }, { id, data }) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await RecipeService.delete(id, data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Product.js